/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OsrmIntersection } from "./OsrmIntersection";
import {
  OsrmIntersectionFromJSON,
  OsrmIntersectionFromJSONTyped,
  OsrmIntersectionToJSON,
  OsrmIntersectionToJSONTyped,
} from "./OsrmIntersection";
import type { OsrmStepManeuver } from "./OsrmStepManeuver";
import {
  OsrmStepManeuverFromJSON,
  OsrmStepManeuverFromJSONTyped,
  OsrmStepManeuverToJSON,
  OsrmStepManeuverToJSONTyped,
} from "./OsrmStepManeuver";
import type { OsrmBannerInstruction } from "./OsrmBannerInstruction";
import {
  OsrmBannerInstructionFromJSON,
  OsrmBannerInstructionFromJSONTyped,
  OsrmBannerInstructionToJSON,
  OsrmBannerInstructionToJSONTyped,
} from "./OsrmBannerInstruction";
import type { OsrmVoiceInstruction } from "./OsrmVoiceInstruction";
import {
  OsrmVoiceInstructionFromJSON,
  OsrmVoiceInstructionFromJSONTyped,
  OsrmVoiceInstructionToJSON,
  OsrmVoiceInstructionToJSONTyped,
} from "./OsrmVoiceInstruction";

/**
 * A maneuver such as a turn or merge, followed by travel along a single road or path.
 * @export
 * @interface OsrmRouteStep
 */
export interface OsrmRouteStep {
  /**
   * The distance traveled by the route, in meters.
   * @type {number}
   * @memberof OsrmRouteStep
   */
  distance: number;
  /**
   * The estimated travel time, in number of seconds.
   * @type {number}
   * @memberof OsrmRouteStep
   */
  duration: number;
  /**
   * An encoded polyline (https://developers.google.com/maps/documentation/utilities/polylinealgorithm) with 6 digits of decimal precision (NOTE: most implementations default to 5).
   * @type {string}
   * @memberof OsrmRouteStep
   */
  geometry: string;
  /**
   *
   * @type {number}
   * @memberof OsrmRouteStep
   */
  weight?: number;
  /**
   * The name of the segment (ex: road) being traversed
   * @type {string}
   * @memberof OsrmRouteStep
   */
  name?: string;
  /**
   * A reference number of code for the segment being traversed.
   * @type {string}
   * @memberof OsrmRouteStep
   */
  ref?: string;
  /**
   * Pronunciation of the name (if available). The format of this varies by implementation/vendor.
   * @type {string}
   * @memberof OsrmRouteStep
   */
  pronunciation?: string;
  /**
   *
   * @type {string}
   * @memberof OsrmRouteStep
   */
  destinations?: string;
  /**
   *
   * @type {string}
   * @memberof OsrmRouteStep
   */
  exits?: string;
  /**
   * The mode of travel.
   * @type {string}
   * @memberof OsrmRouteStep
   */
  mode: string;
  /**
   *
   * @type {OsrmStepManeuver}
   * @memberof OsrmRouteStep
   */
  maneuver: OsrmStepManeuver;
  /**
   *
   * @type {Array<OsrmIntersection>}
   * @memberof OsrmRouteStep
   */
  intersections?: Array<OsrmIntersection>;
  /**
   * The name of the traffic circle.
   * @type {string}
   * @memberof OsrmRouteStep
   */
  rotaryName?: string;
  /**
   * Pronunciation of the rotary name (if available). The format of this varies by implementation/vendor.
   * @type {string}
   * @memberof OsrmRouteStep
   */
  rotaryPronunciation?: string;
  /**
   * The side of the road on which driving is legal for this step.
   * @type {OsrmRouteStepDrivingSideEnum}
   * @memberof OsrmRouteStep
   */
  drivingSide?: OsrmRouteStepDrivingSideEnum;
  /**
   * A list of announcements which should be spoken at various points along the maneuver.
   * @type {Array<OsrmVoiceInstruction>}
   * @memberof OsrmRouteStep
   */
  voiceInstructions?: Array<OsrmVoiceInstruction>;
  /**
   * A list of announcements which should be displayed prominently on screen at various points along the maneuver.
   * @type {Array<OsrmBannerInstruction>}
   * @memberof OsrmRouteStep
   */
  bannerInstructions?: Array<OsrmBannerInstruction>;
  /**
   * The style of speed limit signs used along the step.
   * @type {OsrmRouteStepSpeedLimitSignEnum}
   * @memberof OsrmRouteStep
   */
  speedLimitSign?: OsrmRouteStepSpeedLimitSignEnum;
  /**
   * The unit of measure that is used locally along the step. This may be different from the unit used in maxspeed annotations, and is provided so that apps can localize their display.
   * @type {string}
   * @memberof OsrmRouteStep
   */
  speedLimitUnit?: string;
}

/**
 * @export
 */
export const OsrmRouteStepDrivingSideEnum = {
  Left: "left",
  Right: "right",
} as const;
export type OsrmRouteStepDrivingSideEnum =
  (typeof OsrmRouteStepDrivingSideEnum)[keyof typeof OsrmRouteStepDrivingSideEnum];

/**
 * @export
 */
export const OsrmRouteStepSpeedLimitSignEnum = {
  Mutcd: "mutcd",
  Vienna: "vienna",
} as const;
export type OsrmRouteStepSpeedLimitSignEnum =
  (typeof OsrmRouteStepSpeedLimitSignEnum)[keyof typeof OsrmRouteStepSpeedLimitSignEnum];

/**
 * Check if a given object implements the OsrmRouteStep interface.
 */
export function instanceOfOsrmRouteStep(value: object): value is OsrmRouteStep {
  if (!("distance" in value) || value["distance"] === undefined) return false;
  if (!("duration" in value) || value["duration"] === undefined) return false;
  if (!("geometry" in value) || value["geometry"] === undefined) return false;
  if (!("mode" in value) || value["mode"] === undefined) return false;
  if (!("maneuver" in value) || value["maneuver"] === undefined) return false;
  return true;
}

export function OsrmRouteStepFromJSON(json: any): OsrmRouteStep {
  return OsrmRouteStepFromJSONTyped(json, false);
}

export function OsrmRouteStepFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OsrmRouteStep {
  if (json == null) {
    return json;
  }
  return {
    distance: json["distance"],
    duration: json["duration"],
    geometry: json["geometry"],
    weight: json["weight"] == null ? undefined : json["weight"],
    name: json["name"] == null ? undefined : json["name"],
    ref: json["ref"] == null ? undefined : json["ref"],
    pronunciation:
      json["pronunciation"] == null ? undefined : json["pronunciation"],
    destinations:
      json["destinations"] == null ? undefined : json["destinations"],
    exits: json["exits"] == null ? undefined : json["exits"],
    mode: json["mode"],
    maneuver: OsrmStepManeuverFromJSON(json["maneuver"]),
    intersections:
      json["intersections"] == null
        ? undefined
        : (json["intersections"] as Array<any>).map(OsrmIntersectionFromJSON),
    rotaryName: json["rotary_name"] == null ? undefined : json["rotary_name"],
    rotaryPronunciation:
      json["rotary_pronunciation"] == null
        ? undefined
        : json["rotary_pronunciation"],
    drivingSide:
      json["driving_side"] == null ? undefined : json["driving_side"],
    voiceInstructions:
      json["voiceInstructions"] == null
        ? undefined
        : (json["voiceInstructions"] as Array<any>).map(
            OsrmVoiceInstructionFromJSON,
          ),
    bannerInstructions:
      json["bannerInstructions"] == null
        ? undefined
        : (json["bannerInstructions"] as Array<any>).map(
            OsrmBannerInstructionFromJSON,
          ),
    speedLimitSign:
      json["speedLimitSign"] == null ? undefined : json["speedLimitSign"],
    speedLimitUnit:
      json["speedLimitUnit"] == null ? undefined : json["speedLimitUnit"],
  };
}

export function OsrmRouteStepToJSON(json: any): OsrmRouteStep {
  return OsrmRouteStepToJSONTyped(json, false);
}

export function OsrmRouteStepToJSONTyped(
  value?: OsrmRouteStep | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    distance: value["distance"],
    duration: value["duration"],
    geometry: value["geometry"],
    weight: value["weight"],
    name: value["name"],
    ref: value["ref"],
    pronunciation: value["pronunciation"],
    destinations: value["destinations"],
    exits: value["exits"],
    mode: value["mode"],
    maneuver: OsrmStepManeuverToJSON(value["maneuver"]),
    intersections:
      value["intersections"] == null
        ? undefined
        : (value["intersections"] as Array<any>).map(OsrmIntersectionToJSON),
    rotary_name: value["rotaryName"],
    rotary_pronunciation: value["rotaryPronunciation"],
    driving_side: value["drivingSide"],
    voiceInstructions:
      value["voiceInstructions"] == null
        ? undefined
        : (value["voiceInstructions"] as Array<any>).map(
            OsrmVoiceInstructionToJSON,
          ),
    bannerInstructions:
      value["bannerInstructions"] == null
        ? undefined
        : (value["bannerInstructions"] as Array<any>).map(
            OsrmBannerInstructionToJSON,
          ),
    speedLimitSign: value["speedLimitSign"],
    speedLimitUnit: value["speedLimitUnit"],
  };
}
